/**
 * Short Term Feature Tests
 */
export enum testNames {
    CONDITION_QUESTION_EMAIL = 'condition-question-email',
    KBB_HOLDOUT = 'kbb-holdout',
    KBB_VALUATION = 'kbb-valuation',
    SELLING_OR_TRADING = 'selling-or-trading-v2',
    SELLING_OR_TRADING_PREFILL_TRADE = 'selling-or-trading-prefill-trade',
    WALLET_PASS = 'wallet-pass',
}

/**
 * Long Term feature flag names
 */
export enum featureName {
    OFFER_DETAILS_ON_SUBMIT = 'offer-details-on-submit',
    PHOTO_CAPTURE = 'photo-capture',
}
